/* tslint:disable */
/* eslint-disable */
/**
 * Scrivio Contracts API
 * API for managing contracts between organizations and health insurers (verzekeraars). Contracts determine pricing for declarations (declaraties) including negotiated percentages of NZa tariffs and optional volume ceilings (plafonds).  A contract is with a single insurer (`insurerId`) or with a whole insurer concern (`concernId`) — a.s.r. is three labels, Achmea five, and those agreements are negotiated with the concern. Exactly one of the two is set. A consult is still declared to the **label\'s** UZOVI; the concern only says which agreement prices the line, and a label that has a contract of its own is priced by that one.  Multiple contracts per insurer are allowed, each covering different settings (behandelsettings). Each setting can only be covered by one active contract per insurer at a time.  Contracts are created in ACTIVE status. When creating a new contract that covers settings already covered by another active contract for the same insurer, a 409 Conflict error is returned.  All operations are scoped to the authenticated user\'s organization. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost:8080".replace(/\/+$/, "");

export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

export const operationServerMap: ServerMap = {
}
